import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import TableHead from "@mui/material/TableHead";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import ClearIcon from "@mui/icons-material/Clear";
import { NumericFormat } from "react-number-format";
import { Table, TableRow } from "../Cart.style";
import { convertToNumber, formatMoneyData } from "../../../utils/storage";
import { PATH_IMAGE_URL } from "../../../services/api.constant";

interface CartTableProps {
  carts: any[];
  displayRes: { xs: string; sm: string };
  totalPrice: number;
  onGoToDetail: (item: any) => void;
  onEditQuantity: (index: number, quantity: number) => void;
  onRequestDelete: (index: number) => void;
  isPcsCart: boolean;
}

const CartTable = ({
  carts,
  displayRes,
  totalPrice,
  onGoToDetail,
  onEditQuantity,
  onRequestDelete,
  isPcsCart,
}: CartTableProps) => {
  return (
    <Table className="cart-table" aria-label="caption table">
      <TableHead>
        <TableRow>
          <TableCell
            sx={{
              display: displayRes,
              color: "transparent",
            }}>
            NO
          </TableCell>
          <TableCell
            id="cell"
            align="left"
            sx={{
              width: { xs: "28%", sm: "auto" },
              maxWidth: { xs: "28%", sm: "none" },
            }}>
            {isPcsCart ? "PLANT NAME" : "POTS"}
          </TableCell>
          <TableCell
            id="cell"
            align="left"
            sx={{
              width: { xs: "9%", sm: "auto" },
            }}>
            {isPcsCart ? "SIZE" : ""}
          </TableCell>
          <TableCell
            id="cell"
            align="right"
            sx={{
              width: { xs: "18%", sm: 120 },
              minWidth: { xs: 0, sm: 96 },
              maxWidth: { xs: "none", sm: "none" },
              padding: { xs: "0 1px", sm: 0 },
              overflow: "visible",
            }}>
            QTY
          </TableCell>
          <TableCell
            id="cell"
            align="right"
            sx={{ width: { xs: "20%", sm: "auto" }, padding: { xs: "0 2px", sm: 0 } }}>
            PRICE
          </TableCell>
          <TableCell
            id="cell"
            align="right"
            sx={{ width: { xs: "20%", sm: "auto" }, padding: { xs: "0 2px", sm: 0 } }}>
            TOTAL
          </TableCell>
          <TableCell
            id="cell"
            sx={{
              width: { xs: "5%", sm: "auto" },
              minWidth: { xs: 36, sm: 0 },
              maxWidth: { xs: 44, sm: "none" },
              padding: { xs: "0 4px", sm: 0 },
              verticalAlign: "middle",
            }}
          />
        </TableRow>
      </TableHead>

      <TableBody>
        {carts?.map((item: any, index: number) => {
          const totalPriceItem = Number(item.price) * Number(item.quantity);
          const imagePath =
            item?.thumbnail && PATH_IMAGE_URL + item.thumbnail?.[0]?.image_path;

          return (
            <TableRow key={index}>
              <TableCell
                onClick={() => onGoToDetail(item)}
                sx={{ cursor: "pointer", display: displayRes }}>
                <Box
                  component={"img"}
                  src={imagePath}
                  style={{ width: 80, height: 80, objectFit: "cover" }}
                />
              </TableCell>
              <TableCell
                id="cell"
                onClick={() => onGoToDetail(item)}
                sx={{
                  cursor: "pointer",
                  width: { xs: "28%", sm: "auto" },
                  maxWidth: { xs: "28%", sm: "none" },
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}>
                {item.product_name ?? item.name}
              </TableCell>
              <TableCell
                id="cell"
                align="left"
                sx={{
                  width: { xs: "9%", sm: "auto" },
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}>
                {item.sizeName !== "default" && item.sizeName}
              </TableCell>
              <TableCell
                id="cell"
                align="right"
                sx={{
                  width: { xs: "18%", sm: 120 },
                  minWidth: { xs: 0, sm: 96 },
                  maxWidth: { xs: "none", sm: "none" },
                  padding: { xs: "0 1px", sm: 0 },
                  verticalAlign: "middle",
                  overflow: "visible",
                }}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                    width: "100%",
                    minWidth: 0,
                  }}>
                  <NumericFormat
                    className="number-input number-input--cart"
                    value={item.quantity}
                    inputMode="numeric"
                    allowNegative={false}
                    onChange={(event) => {
                      onEditQuantity(index, convertToNumber(event.target.value));
                    }}
                    thousandSeparator=","
                  />
                </Box>
              </TableCell>
              <TableCell
                id="cell"
                align="right"
                sx={{ padding: { xs: "0 2px", sm: 0 }, width: { xs: "20%", sm: "auto" } }}>
                {formatMoneyData(item.price)}
              </TableCell>
              <TableCell
                id="cell"
                align="right"
                sx={{ padding: { xs: "0 2px", sm: 0 }, width: { xs: "20%", sm: "auto" } }}>
                {formatMoneyData(totalPriceItem)}
              </TableCell>
              <TableCell
                sx={{
                  width: { xs: "5%", sm: "auto" },
                  minWidth: { xs: 36, sm: 0 },
                  maxWidth: { xs: 44, sm: "none" },
                  padding: { xs: "0 4px", sm: "0px", md: "16px" },
                  verticalAlign: "middle",
                }}
                onClick={() => onRequestDelete(index)}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "100%",
                    minHeight: { xs: 40, sm: "auto" },
                  }}>
                  <ClearIcon
                    className="delete_pro cart-delete-icon"
                    sx={{ fontSize: { xs: 22, sm: 24 } }}
                  />
                </Box>
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>

      <TableHead>
        <TableRow>
          <TableCell
            colSpan={7}
            sx={{
              borderBottom: "none",
              padding: { xs: "12px 0 0", sm: "14px 0 0" },
              verticalAlign: "middle",
              width: "100%",
              maxWidth: "100%",
              boxSizing: "border-box",
            }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: { xs: 1, sm: 2 },
                pb: 1.25,
                borderBottom: "1px solid #000",
                fontWeight: 700,
                textTransform: "uppercase",
                fontSize: { xs: "12px", sm: "15px" },
                letterSpacing: { xs: "0.02em", sm: "0.03em" },
                color: "#000",
                width: "100%",
                maxWidth: "100%",
                minWidth: 0,
                boxSizing: "border-box",
              }}>
              <Typography
                component="span"
                sx={{ fontWeight: 700, minWidth: 0, pr: 0.5 }}>
                TOTAL AMOUNT
              </Typography>
              <Typography
                component="span"
                sx={{ fontWeight: 700, flexShrink: 0, textAlign: "right" }}>
                {formatMoneyData(totalPrice)}
              </Typography>
            </Box>
          </TableCell>
        </TableRow>
      </TableHead>
    </Table>
  );
};

export default CartTable;

